import { useContext } from 'react';
import type { User } from 'firebase/auth';

import { AuthContext, type AuthContextT, type AuthContextValueT } from './AuthContext';

export function useAuth<TUser = User>(
  context: AuthContextT<TUser> = AuthContext as unknown as AuthContextT<TUser>
): AuthContextValueT<TUser> {
  const value = useContext(context);
  if (value === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return value;
}
